import './product.scss';

const product = () => {

    const productTabs = document.querySelectorAll('.product-page-section .tabs [data-tab-target]')
    const productTabContents = document.querySelectorAll('.product-page-section .tab-content [data-tab-content]')
    const dropdownBtn = document.querySelector('.dropdown-mobile');
    const dropdownCategories = document.querySelector('.dropdown-mobile-categories');

    const dropdownBtnDesktop = document.querySelector('.dropdown-desktop');
    const dropdownCategoriesDesktop = document.querySelector('.dropdown-desktop-categories');

    if (dropdownBtn) {
        dropdownBtn.addEventListener('click', () => {
            dropdownCategories.classList.toggle('active');
            dropdownBtn.classList.toggle('active');
        });
    }

    document.addEventListener('click', (event) => {

        if (dropdownBtn) {

            const targetElement = event.target;
            const dropdownClicked = targetElement.closest('.dropdown-mobile');
            const dropdownContent = targetElement.closest('.dropdown-mobile-categories');

            if (!dropdownClicked && !dropdownContent) {
                dropdownCategories.classList.remove('active');
                dropdownBtn.classList.remove('active');
            }
        }
    });

    if (dropdownBtnDesktop) {
        dropdownBtnDesktop.addEventListener('click', () => {
            dropdownCategoriesDesktop.classList.toggle('active');
            dropdownBtnDesktop.classList.toggle('active');
        });
    }

    document.addEventListener('click', (event) => {

        if (dropdownBtnDesktop) {

            const targetElement = event.target;
            const dropdownClickedDesktop = targetElement.closest('.dropdown-desktop');
            const dropdownContentDesktop = targetElement.closest('.dropdown-desktop-categories');

            if (!dropdownClickedDesktop && !dropdownContentDesktop) {
                dropdownCategoriesDesktop.classList.remove('active');
                dropdownBtnDesktop.classList.remove('active');
            }
        }
    });

    productTabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const target = document.querySelector(tab.dataset.tabTarget)
            productTabContents.forEach(tabContent => {
                tabContent.classList.remove('active')
            })
            productTabs.forEach(tab => {
                tab.classList.remove('active')
            })
            tab.classList.add('active')
            target.classList.add('active')
        })
    })
}

export default product;


